import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MuiInput from '@material-ui/core/Input';
import { useForkRef, ownerDocument } from '@material-ui/core/utils';
import { refType } from '@material-ui/utils';
import { useDensity, withStyles } from '@jpmuitk/theme';
import { useFormFieldProps } from '@jpmuitk/form-field';
import { useA11yProps } from '@jpmuitk/utils';
import AdornmentContext from './internal/AdornmentContext';
import { style } from './style.js';

function getSelectionRange(highlight, position, input) {
  // Handle highlight first so it takes priority over cursorPositionOnFocus
  if (highlight === true) {
    return [0, input.value.length];
  }

  if (Array.isArray(highlight) && highlight.length > 1) {
    return [highlight[0], highlight[1]];
  }

  if (position === 'start') {
    return [0, 0];
  }

  if (position === 'end') {
    return [input.value.length, input.value.length];
  }

  if (!isNaN(position)) {
    return [position, position];
  }

  return [null, null];
}

function isSafari() {
  return navigator.userAgent.toLowerCase().indexOf('safari') !== -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1;
}

function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
}

function mergeA11yProps(a11yProps, inputProps) {
  var ariaLabelledBy = classnames(a11yProps['aria-labelledby'], inputProps['aria-labelledby']);
  return _assign({}, a11yProps, inputProps, {
    // The weird filtering is due to TokenizedInputBase.
    'aria-labelledby': ariaLabelledBy ? _toConsumableArray(new Set(ariaLabelledBy.split(' '))).join(' ') : null
  });
}

var Input = /*#__PURE__*/forwardRef(function Input(props, ref) {
  var _classnames;

  var classes = props.classes,
      className = props.className,
      _props$cursorPosition = props.cursorPositionOnFocus,
      cursorPositionOnFocus = _props$cursorPosition === void 0 ? false : _props$cursorPosition,
      defaultValueProp = props.defaultValue,
      densityProp = props.density,
      disabledProp = props.disabled,
      _props$emptyReadOnlyM = props.emptyReadOnlyMarker,
      emptyReadOnlyMarker = _props$emptyReadOnlyM === void 0 ? '—' : _props$emptyReadOnlyM,
      endAdornmentProp = props.endAdornment,
      _props$highlightOnFoc = props.highlightOnFocus,
      highlightOnFocus = _props$highlightOnFoc === void 0 ? false : _props$highlightOnFoc,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      multiline = props.multiline,
      onChange = props.onChange,
      onMouseDown = props.onMouseDown,
      onMouseMove = props.onMouseMove,
      onMouseUp = props.onMouseUp,
      readOnlyProp = props.readOnly,
      startAdornmentProp = props.startAdornment,
      textAlign = props.textAlign,
      inField = props.inField,
      value = props.value,
      rest = _objectWithoutProperties(props, ["classes", "className", "cursorPositionOnFocus", "defaultValue", "density", "disabled", "emptyReadOnlyMarker", "endAdornment", "highlightOnFocus", "inputProps", "inputRef", "multiline", "onChange", "onMouseDown", "onMouseMove", "onMouseUp", "readOnly", "startAdornment", "textAlign", "inField", "value"]);

  var _props$classes = props.classes,
      field = _props$classes.field,
      readOnly = _props$classes.readOnly,
      emptyReadOnly = _props$classes.emptyReadOnly,
      endAdornment = _props$classes.endAdornment,
      startAdornment = _props$classes.startAdornment,
      touchDensity = _props$classes.touchDensity,
      lowDensity = _props$classes.lowDensity,
      focused = _props$classes.focused,
      mediumDensity = _props$classes.mediumDensity,
      highDensity = _props$classes.highDensity,
      centerTextAlign = _props$classes.centerTextAlign,
      leftTextAlign = _props$classes.leftTextAlign,
      rightTextAlign = _props$classes.rightTextAlign,
      prefixContainer = _props$classes.prefixContainer,
      suffixContainer = _props$classes.suffixContainer,
      classesRest = _objectWithoutProperties(_props$classes, ["field", "readOnly", "emptyReadOnly", "endAdornment", "startAdornment", "touchDensity", "lowDensity", "focused", "mediumDensity", "highDensity", "centerTextAlign", "leftTextAlign", "rightTextAlign", "prefixContainer", "suffixContainer"]);

  var density = useDensity(densityProp);

  var _useFormFieldProps = useFormFieldProps(),
      inFormField = _useFormFieldProps.inFormField,
      popoutMode = _useFormFieldProps.popoutMode,
      popoutActions = _useFormFieldProps.popoutActions,
      formFieldProps = _objectWithoutProperties(_useFormFieldProps, ["inFormField", "popoutMode", "popoutActions"]);

  var a11yProps = useA11yProps();

  var a11yReadOnly = a11yProps.readOnly,
      a11yDisabled = a11yProps.disabled,
      restA11y = _objectWithoutProperties(a11yProps, ["readOnly", "disabled"]);

  var focusVisibleClassName = inFormField || inField ? classes.field : classes.focused;
  var disabled = disabledProp || inFormField && formFieldProps.disabled;
  var isReadOnly = readOnlyProp || a11yReadOnly;
  var inputProps = mergeA11yProps(restA11y, inputPropsProp);
  var isEmptyReadOnly = isReadOnly && !defaultValueProp && !value;
  var isControlled = value !== undefined;
  var defaultValue = isEmptyReadOnly && !isControlled ? emptyReadOnlyMarker : defaultValueProp;
  var inputRef = useRef(null);
  var handleInputRef = useForkRef(inputRef, inputRefProp);
  var wasClick = useRef(false);
  var timeoutRef = useRef(null);
  var originalCursorPosition = useRef(null);
  var selectionInProgress = useRef(false);
  var mouseMovement = useRef(0);

  var handleChange = function handleChange(event) {
    if (multiline && popoutMode && popoutActions) {
      popoutActions.refresh();
    }

    if (onChange) {
      onChange(event);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    wasClick.current = true;

    if (onMouseDown) {
      onMouseDown(event);
    }
  };

  var handleMouseMove = function handleMouseMove(event) {
    if (selectionInProgress.current) {
      mouseMovement.current += Math.abs(event.movementX) + Math.abs(event.movementY); // Prevents the slightest mouse movement causing the cursor to be repositioned.

      if (mouseMovement.current < 3) {
        event.preventDefault();
        return;
      } // Allows continued highlighting if the mouse down is part of a selection.


      inputRef.current.setSelectionRange(originalCursorPosition.current, originalCursorPosition.current); // Reset so originalCursorPosition is only set once.

      selectionInProgress.current = false;
    }

    if (onMouseMove) {
      onMouseMove(event);
    }
  };

  var selection = useRef(null);

  var handleMouseUp = function handleMouseUp(event) {
    var isValidBrowser = isFirefox() || isSafari();

    if (selectionInProgress.current && mouseMovement.current < 3 && isValidBrowser && Array.isArray(selection.current)) {
      var _selection$current = _slicedToArray(selection.current, 2),
          start = _selection$current[0],
          end = _selection$current[1];

      setTimeout(function () {
        if (inputRef.current.selectionStart !== start || inputRef.current.selectionEnd !== end) {
          inputRef.current.setSelectionRange(start, end);
        }
      }, 0);
    }

    wasClick.current = false;
    selectionInProgress.current = false;
    mouseMovement.current = 0;

    if (onMouseUp) {
      onMouseUp(event);
    }
  };

  var wasWindowFocus = useRef(false);
  useEffect(function () {
    if (cursorPositionOnFocus || highlightOnFocus) {
      var handleFocusBehaviour = function handleFocusBehaviour() {
        var _getSelectionRange = getSelectionRange(highlightOnFocus, cursorPositionOnFocus, inputRef.current),
            _getSelectionRange2 = _slicedToArray(_getSelectionRange, 2),
            start = _getSelectionRange2[0],
            end = _getSelectionRange2[1];

        if (start !== null && end !== null) {
          clearTimeout(timeoutRef.current);
          var needsTimeout = isSafari() || wasClick.current;

          if (wasClick.current) {
            selectionInProgress.current = true;
            mouseMovement.current = 0;
          }

          selection.current = [start, end]; // Keyboard focus needs to be outside setTimeout otherwise a flash of selected text appears.

          if (needsTimeout) {
            // Make's setSelectionRange run after browser has set cursor position.
            timeoutRef.current = setTimeout(function () {
              if (wasClick.current) {
                originalCursorPosition.current = inputRef.current.selectionStart;
              }

              inputRef.current.setSelectionRange(start, end);
            }, 0);
          } else {
            inputRef.current.setSelectionRange(start, end);
          }
        }
      };

      var handleFocusIn = function handleFocusIn() {
        if ((cursorPositionOnFocus || highlightOnFocus) && !wasWindowFocus.current) {
          handleFocusBehaviour();
        } // Ignore focus of textfield on window focus


        if (wasWindowFocus.current) {
          wasWindowFocus.current = false;
        }
      }; // Reset everything on window re-focus


      var handleWindowFocus = function handleWindowFocus() {
        if (ownerDocument(inputRef.current).visibilityState === 'visible' && ownerDocument(inputRef.current).activeElement === inputRef.current) {
          wasClick.current = false;
          selectionInProgress.current = false;
          mouseMovement.current = 0;
          wasWindowFocus.current = true;
        }
      };

      var event = isSafari() || isFirefox() ? 'focusin' : 'focus';
      var input = inputRef.current;
      input.addEventListener(event, handleFocusIn);
      ownerDocument(input).addEventListener('visibilitychange', handleWindowFocus);
      return function () {
        input.removeEventListener(event, handleFocusIn);
        ownerDocument(input).removeEventListener('visibilitychange', handleWindowFocus);
      };
    }

    return undefined;
  }, [cursorPositionOnFocus, highlightOnFocus]);

  var getEndAdornment = function getEndAdornment() {
    if (endAdornmentProp) {
      return /*#__PURE__*/React.createElement(AdornmentContext.Provider, {
        value: {
          suffix: true
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.suffixContainer
      }, endAdornmentProp));
    }

    return null;
  };

  var getStartAdornment = function getStartAdornment() {
    if (startAdornmentProp) {
      return /*#__PURE__*/React.createElement(AdornmentContext.Provider, {
        value: {
          prefix: true
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.prefixContainer
      }, startAdornmentProp));
    }
  };

  return /*#__PURE__*/React.createElement(MuiInput, _assign({
    className: classnames(className, classes["".concat(density, "Density")], (_classnames = {}, _defineProperty(_classnames, classes["".concat(textAlign, "TextAlign")], textAlign), _defineProperty(_classnames, classes.field, inFormField), _defineProperty(_classnames, classes.readOnly, isReadOnly), _defineProperty(_classnames, classes.emptyReadOnly, isEmptyReadOnly), _defineProperty(_classnames, classes.startAdornment, !!startAdornmentProp), _defineProperty(_classnames, classes.endAdornment, !!endAdornmentProp), _classnames)),
    classes: _assign({
      focused: focusVisibleClassName
    }, classesRest),
    defaultValue: defaultValue,
    disableUnderline: true,
    disabled: disabled,
    endAdornment: getEndAdornment(),
    inputProps: inputProps,
    inputRef: handleInputRef,
    multiline: multiline,
    onChange: handleChange,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    readOnly: isReadOnly,
    ref: ref,
    startAdornment: getStartAdornment(),
    value: value
  }, rest));
});
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  /**
   * The className(s) of the component.
   */
  className: PropTypes.string,

  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * Determines the position of the text cursor on focus of the input.
   * start = place cursor at the start
   * end = place cursor at the end
   * # = index to place the cursor
   */
  cursorPositionOnFocus: PropTypes.oneOfType([PropTypes.oneOf(['start', 'end']), PropTypes.number]),

  /**
   * @external - material-ui
   * The default input value, useful when not controlling the component.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Determines the density of the component.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * @external - material-ui
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The marker to use in an empty read only Input.
   * Use `''` to disable this feature. Defaults to '—'.
   */
  emptyReadOnlyMarker: PropTypes.string,

  /**
   * @external - material-ui
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * @external - material-ui
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * @external - material-ui
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determines what gets highlighted on focus of the input.
   *
   * If `true` all text will be highlighted.
   * If an array text between those indices will be highlighted
   * e.g. [0,1] will highlight the first character.
   */
  highlightOnFocus: function highlightOnFocus(props, propName, componentName) {
    var errors = [];
    var cursorPositionOnFocus = props.cursorPositionOnFocus,
        highlightOnFocus = props.highlightOnFocus;
    var isArrayOf2Numbers = Array.isArray(highlightOnFocus) && highlightOnFocus.length === 2 && highlightOnFocus.every(function (number) {
      return !isNaN(number);
    });

    if (highlightOnFocus != null && typeof highlightOnFocus !== 'boolean' && !isArrayOf2Numbers) {
      errors.push('Invalid prop `highlightOnFocus` supplied to' + " `".concat(componentName, "`. Validation failed."));
    }

    if (highlightOnFocus && cursorPositionOnFocus) {
      errors.push('`highlightOnFocus` and `cursorPosition` cannot be used together.');
    }

    if (errors.length > 0) {
      return new Error(errors.join('\n'));
    }
  },

  /**
   * @external - material-ui
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * @external - material-ui
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /**
   * @external - material-ui
   * Attributes applied to the `input` element.
   */
  inputProps: PropTypes.objectOf(PropTypes.any),

  /**
   * @external - material-ui
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: refType,

  /**
   * @external - material-ui
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * @external - material-ui
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @external - material-ui
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: PropTypes.func,

  /**
   * @external - material-ui
   * Callback fired by the input component onMouseDown.
   *
   * @param {object} event The event source of the callback
   */
  onMouseDown: PropTypes.func,

  /**
   * @external - material-ui
   * Callback fired by the input component onMouseMove.
   *
   * @param {object} event The event source of the callback
   */
  onMouseMove: PropTypes.func,

  /**
   * @external - material-ui
   * Callback fired by the input component onMouseUp.
   *
   * @param {object} event The event source of the callback
   */
  onMouseUp: PropTypes.func,

  /**
   * @external - material-ui
   * The Input value is Readonly
   */
  readOnly: PropTypes.bool,

  /**
   * @external - material-ui
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @external - material-ui
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @external - material-ui
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   *
   * Determines the alignment of the input text.
   */
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),

  /**
   * @external - material-ui
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: PropTypes.string,

  /**
   * @external - material-ui
   * The input value, required for a controlled component.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
} : void 0; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(style, {
  name: 'Input'
})(Input);